import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrl } from '@iris/api-query';
import { WorkflowApiServiceBase } from '@iris/common/services/workflow/workflow-api.service';

@Injectable({ providedIn: 'root' })
@ApiUrl('/workflow/workflows')
export class BackendWorkflowApiService extends WorkflowApiServiceBase {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  }
}
